import { CButton } from './CButton.js';

const CButtonPlugin = {
    install: (app) => {
        app.component(CButton.name, CButton);
    },
};

export { CButton, CButtonPlugin };
//# sourceMappingURL=index.js.map
